import {getRoot, types, addDisposer} from 'mobx-state-tree';
import Customer from './Customer';
import axios from "axios";

export default types.model('Account',
    {
        
        isLoggingIn: types.optional(types.boolean, false),
        Roles: types.optional(types.array(types.string), []),
        //UserName: types.optional(types.string, ""),
        Email: types.optional(types.string, ""),
        UserId: types.optional(types.number, 0),
        CustomerName: types.optional(types.string, ""),
        errorMessages: types.optional(types.array(types.string), []), 
        Customers: types.optional(types.array(Customer), []),
        CustomerId: types.maybeNull(types.number),

        //ActiveCustomer: types.maybeNull(types.reference(Customer)),
        Ready: types.optional(types.boolean, true),
        ShowSettingsDialog: types.optional(types.boolean, false),
        
        LoginUrl: types.optional(types.string, ""),
        ProfileUrl: types.optional(types.string, ""),
        
    }).views(self => ({
        get isLoggedIn() {
            return self.UserId > 0 && self.Email !== "";
        },
        
        get navigation() {
            return getRoot(self).navigation;
        },

        get customerSearchResult() {
            return self.Customers.map((customer) => ({
                label: customer.Name + ", " + customer.Number,
                value: customer.CustomerId
            }));
        },

        inRole(role) {
            return self.Roles.findIndex((x) => x === role) > -1;
        },
    
        get activeCustomer() {
            return self.Customers.find(x => x.Id === self.navigation.getCustomerId());
        },

        showSettings() {
            // returns true if we need to display customer selector
            
            // if (self.navigation.TemplateAlias === "IComAccount") {
            //     return false;
            // }
            //
            
            if (self.isLoggedIn) {
                
                if (!self.Ready) return true;
                
                if(self.ShowSettingsDialog) return true;

                if (self.Customers.length > 1 || self.Roles.indexOf('icom-admin') > -1) {
                    const customerId = self.navigation.getCustomerId();
                    if (!self.Customers.find(x => x.Id === customerId)) {
                        return true;
                    }

                } else {
                    if (!self.navigation.getCustomerId() && self.Customers.length > 0) {
                        self.setCustomer(self.Customers[0]);
                    }
                }
            }

            return false;
        },
    
       


    })).actions(self => {
        const disposables = [];

        return {
            afterCreate() {
                const serverRender = typeof window === 'undefined';
                if (self.isLoggedIn) {
                    //if (!self.Ready) return true;

                    if (self.Customers.length > 1) {
                        // const customerId = self.navigation.getCustomerId();
                        
                        // if (!self.Customers.find(x => x.Id === customerId)) {
                        //     return true;
                        // }
                    } else if(self.Customers.length === 1) {
                        self.setCustomer(self.Customers[0]);
                        //return false;
                    }
                }

                if (!serverRender) {
                    self.broadcastChannel = new BroadcastChannel("icom-account");
                    self.broadcastChannel.addEventListener('message', (event) => {
                        switch (event.data) {
                            case "login":
                            case "logout":
                                window.location = window.location;
                                break;
                        }
                    });
                }

                addDisposer(self,
                    () => {
                        if (self.broadcastChannel) self.broadcastChannel.close();
                    }
                );
            },

            async login(formValues) {
                self.setIsLoggingIn(true);
                try {
                    const res = await self.performLogin(formValues);
                    
                    if (res) {
                        if (res.status && res.status==='error') {
                            throw { status: 'error', messages: res.errors.messages };
                        } else {
                            //self.setIsLoggedIn(true);
                            await self.setAccount(res);
                            if(self.broadcastChannel) self.broadcastChannel.postMessage("login");
                            return res;
                        }

                    }
                } finally {
                    self.setIsLoggingIn(false);
                }

                return null;

            },

            async startPasswordReset(formValues) {
                const res = await self.request("/Umbraco/Api/Account/StartPasswordReset",
                    {
                        Email: formValues.email,
                        CultureCode: self.navigation.CultureCode

                    });
                if (res.errors) {
                    throw res;
                }

                console.debug("reset password ", res);
                return res;
            },

            setErrorMessages(messages) {
                self.errorMessages = messages;
            },

            async searchCustomers(searchValue) {
                const res = await self.getCustomers(searchValue, "account.searchCustomers");
                await self.setCustomers(res.Customers);
                //console.debug(self.Customers);
                //return self.Customers;
            },
            

            async setCustomers(customers) {
                self.Customers = customers;
            },

            setCustomer(customer) {

                // Add to local list
                if (!self.Customers.find(x => x.Id === customer.Id)) {
                    self.Customers.push(customer);
                }
                
                self.CustomerId = customer != null ? customer.Id : null;
                //self.ActiveCustomer = customer;
                
                // get reference
                
                //self.ActiveCustomer = self.Customers.find(x=>x.Id === customer.Id);
                 
                self.navigation.setLocationCustomerId(customer != null ? customer.Id : null);
                
            },

            getCustomerList() {
                if (self.isLoggedIn) {
                    return self.searchCustomers("");
                }
                return null;
            },

            getCustomers(searchValue, sender) {
                console.debug("getCustomers", sender);
                return self.request("/Umbraco/Api/Account/GetCustomers", { Name: searchValue });
            },

            setCustomerName(name) {
                self.CustomerName = name;
            },

            setReady(value) {
                self.Ready = value;
            },
            
            setShowSettingsDialog(value) {
                self.ShowSettingsDialog = value;  
            },

            async getAccount() {
                console.debug("getAccount");
                self.setReady(false);
                
                const currentCustomerId = self.navigation.getCustomerId();
                if (self.isLoggedIn) {
                    const res = await self.request("/Umbraco/Api/Account/GetAccount", currentCustomerId ? { CustomerId: currentCustomerId } : {});
                    console.debug("Customers res", res);
                    await self.setAccount(res);

                    self.setReady(true);


                }
            },

            async setAccount(accountData) {
                
                self.UserId = accountData.Id;
                self.setEmail(accountData.Email);
                self.setRoles(accountData.Roles);

                // Update mypages-navigation
                //self.navigation.setMypagesNavigation(self.getMyPagesNavigation());

                if (accountData.Customers.length > 0) {
                    await self.setCustomers(accountData.Customers).then(() => {
                        // openChoose is toggled by the template selected from Umbraco
                        //if (!self.navigation.CurrentCustomerId) {
                        //	//self.navigation.openChoose();
                        //}
                    });
                } else {
                    // Propably admins, do not touch location customer id

                }
            },

            async getAccountById(id) {
                const res = await self.request("/Umbraco/Api/Account/GetAccountById", { Id: id });
                console.debug("getAccountById", res);
                return res;
            },

            async addAccount(email) {
                const res = await self.request("/Umbraco/Api/Account/CreateAccount", { Email: email });
                console.debug("addAccount", res);
                return res;
            },

            // setActiveCustomer(customer) {
            //     self.ActiveCustomer = customer;
            // },

            setIsLoggingIn(value) {
                self.isLoggingIn = value;
            },
            setIsLoggedIn(value) {
                self.isLoggedIn = value;
            },

             setEmail(value) {
                 self.Email = value;
             },

            setRoles(value) {
                self.Roles = value;
            },

            changeCustomer(customer) {
                // update IcomContext, and retrive getAccount

            },

            async performLogin(formValues) {
                const { email, password } = formValues;
                console.debug("login start");
                const res = await self.request("/Umbraco/Api/Account/HandleLogin",
                    {
                        CultureCode: self.navigation.CultureCode,
                        Username: email,
                        Password: password
                    });

                return res;
            },

            async Logout() {
                console.debug("logout start");
                const res = await axios.post("/Umbraco/Api/Account/HandleLogout", {});
                if(self.broadcastChannel) self.broadcastChannel.postMessage("logout");
                self.navigation.gotoRoot();
            },

            async forgotPassword(formValues) {
                const res = await self.request("/umbraco/surface/umbracoidentityaccount/handleforgotpassword",
                    { Email: formValues.email });
                console.debug("forgotPassword result:", res);
                return res;
            },

            async searchCustomerToInvite(name) {
                const res = await self.request("/Umbraco/Api/Account/CustomerSearch", { Name: name });
                console.debug("searchCustomerToInvite result:", res);
                return res;
            },

            async searchCustomer(name) {
                const res = await self.request("/Umbraco/Api/Account/CustomerSearch", { Name: name });
                console.debug("searchCustomer result:", res);
                return res;
            },

            async editAccount(editAccountRequest) {
                const res = await self.request("/Umbraco/Api/Account/EditAccount", editAccountRequest);
                console.debug("saveAccount result:", res);
                return res;
            },



            async inviteUser(id, email, message) {
                const res = await self.request("/Umbraco/Api/Account/InviteUser",
                    {
                        Id: id,
                        Email: email,
                        Message: message,
                        CultureCode: self.navigation.CultureCode
                    });
                console.debug("inviteUser result:", res);
                return res;
            },

            async register(formValues) {
                const { email, password } = formValues;
                const res = await self.request("/umbraco/surface/umbracoidentityaccount/handleregistermember",
                    {
                        Email: email,
                        Username: email,
                        Password: "",
                        CultureCode: self.navigation.CultureCode
                    });
                console.debug("registerresult:", res);
                if (res.status === "error") {
                    throw { message: "Error registering user" }
                }
                return res;
            },

            async verifyToken(userId, verifyCode, resetCode) {
                const res = await self.request("/Umbraco/Api/Account/VerifyToken",
                    {
                        UserId: userId,
                        VerifyCode: verifyCode,
                        ResetCode: resetCode,
                        CultureCode: self.navigation.CultureCode 
                    });
                if (res.errors) {
                    throw res;
                }

                console.debug("verifyToken:", res);

                return res;
            },


            async resetAccount(formValues) {
                const res = await self.request("/Umbraco/Api/Account/ResetAccount",
                    {
                        UserId: formValues.userId,
                        VerifyCode: formValues.verifycode,
                        ResetCode: formValues.resetcode,
                        Password: formValues.password,
                        CultureCode: self.navigation.CultureCode
                    });
                if (res.errors) {
                    throw res;
                }

                console.debug("resetAccount:", res);

                return res;
            },

            async searchUsers(input) {
                const res = await self.request("/Umbraco/Api/Account/SearchUser", { Input: input });
                //console.debug("searchUsers", res);
                return res.Result;
            },

            async request(path, query = {}) {
                const res = await axios.post(`${path}`, query);
                return res.data;
            }
        }
    });